import React, { useEffect, useState } from "react";
import SearchInput from "../../components/Home/SearchInput/SearchInput";
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../constant/api';
import axios from 'axios';
import { GoHomeFill } from "react-icons/go";

function Sponsored() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [SponsoredProducts, setSponsoredProducts] = useState([]);


    const fetchData = async (url, setter) => {
        try {
            const response = await axios.get(url);
            // console.log(url, response)
            const data = response.data.Data || response.data.data;
            if (data) {
                setter(data);
            }

        } catch (error) {
            console.error(`Error fetching data from ${url}:`, error);
            const errorMessage = error.response?.data?.message || "Failed to fetch data";
            console.log("Fetch data error message:", errorMessage);
        }
    };

    const { sponsorId } = useParams()

    useEffect(() => {
        fetchData(`${BASE_URL}/products/sponsored/${sponsorId}/`, setSponsoredProducts);
    }, []);


    return (
        <>
            <SearchInput
                //   value={searchQuery}
                //   onChange={handleSearchChange}
                placeholder="Search product..."
                head="Sponsored"
                icon={<GoHomeFill />}
            />

            <div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-4">
                    {SponsoredProducts.map((product, index) => {
                        return (
                            <div
                                key={product.id || `sponsored-product-${index}`}
                                className={`flex flex-row justify-between items-center border rounded-lg overflow-hidden  p-4`}
                                style={{
                                    background: 'linear-gradient(87.6deg, #000000 2.01%, #03A800 98.91%)',
                                }}
                            >
                                {/* Text Content */}
                                <div className="flex-grow md:w-2/3 w-1/2 text-white ml-0 md:ml-10">
                                    <h3 className="text-sm md:text-xl lg:text-3xl font-semibold mb-2  line-clamp-1">{product.name}</h3>
                                    <p className="mb-2 line-clamp-1 text-xs md:text-base  w-2/3">{product.description}</p>
                                    <p className="font-medium text-xs md:text-sm lg:text-3xl mb-1">Starting from:</p>
                                    <p className="text-sm sm:text-xl md:text-3xl font-bold">${product.price}</p>
                                </div>

                                {/* Image Container */}
                                <div className="md:w-1/3 w-1/2 h-40 md:h-60 flex justify-end items-center">
                                    <img
                                        src={
                                            product.product_images?.[0]?.image
                                                ? product.product_images[0].image.startsWith(BASE_URL)
                                                    ? product.product_images[0].image
                                                    : `${BASE_URL}${product.product_images[0].image}`
                                                : '/images/default-product.png'
                                        }
                                        alt={product.name}
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </>
    )
}

export default Sponsored;
